import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { UnitQuantity, UnitQuantityControl } from 'src/app/form-controls/unit-quantity/unit-quantity.control';
import { SheetActionControlsBase } from 'src/app/services/sheets-renderer.service';
import { Row, Slot } from 'src/app/types/aggregate-graph.types';
import { SchirmerTearTestRightEyeActionV2 } from 'src/app/types/sheet-action-aggregate-graph.types';
import { ActionFormComponent } from '../../action-form/action-form.component';
import { CommonActionControlsComponent } from '../../common-action-controls/common-action-controls.component';

interface SchirmerTearTestRightEyeActionFormGroup {
	result: FormControl<UnitQuantity | null>;
}

@Component({
    selector: 'app-schirmer-tear-test-right-eye-action-controls-v2',
    templateUrl: './schirmer-tear-test-right-eye-action-controls-v2.component.html',
    styleUrls: ['../../../common.scss', './schirmer-tear-test-right-eye-action-controls-v2.component.scss'],
    imports: [ReactiveFormsModule, UnitQuantityControl, CommonActionControlsComponent, ActionFormComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SchirmerTearTestRightEyeActionControlsComponentV2 implements SheetActionControlsBase, OnInit {

	slot!: Slot | null;
	action!: SchirmerTearTestRightEyeActionV2;

	@Input('slot') set updateSlot(slot: Slot | null) {
		this.slot = slot;
		this.action = slot?.action as SchirmerTearTestRightEyeActionV2;
	}

	@Input() form!: FormGroup<SchirmerTearTestRightEyeActionFormGroup>;
	@Input() item!: Row | null;

	constructor(private formBuilder: FormBuilder) {
	}

    ngOnInit(): void {
        this.form.addControl('result', this.formBuilder.control(this.action?.result ?? null));
    }
}
